var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-selector" },
    [
      _c("div", { staticClass: "event-selector-toolbar" }, [
        _c(
          "div",
          { staticClass: "field" },
          [
            _c("label", [_vm._v("Automation Name: ")]),
            _vm._v(" "),
            _c("a-input", {
              attrs: { placeholder: "Automation Name" },
              model: {
                value: _vm.automationName,
                callback: function ($$v) {
                  _vm.automationName = $$v
                },
                expression: "automationName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "field" },
          [
            _c("label", [_vm._v("Supsis Object: ")]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                attrs: { placeholder: "Select a module" },
                model: {
                  value: _vm.selectedModule,
                  callback: function ($$v) {
                    _vm.selectedModule = $$v
                  },
                  expression: "selectedModule",
                },
              },
              _vm._l(_vm.modules, function (module) {
                return _c(
                  "a-select-option",
                  { key: module, attrs: { value: module } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(module) +
                        "\n                "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c("SupsisTable", {
        attrs: {
          columns: _vm.getCols(),
          rows: _vm.getEvents(),
          "top-pagination": "",
          "empty-data-bordered": "",
          "bottom-pagination": "",
          "pagination-cursor": _vm.pagination,
          options: {
            checkboxOption: _vm.checkboxOption,
            rowStyleOption: _vm.rowStyleOption,
            clipboardOption: _vm.clipboardOption,
            fixedHeader: true,
            id: "events-table",
            borderX: true,
            borderY: true,
          },
        },
        on: {
          "cursor-changed": function (cursor) {
            return (_vm.pagination = cursor)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }